export default __webpack_public_path__ + "static/media/LOOP_ParticlesOnly1_1.f96315a3.mp4";